'use client';

import _defineProperty from "/codebuild/output/src3207/src/s3/01/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/codebuild/output/src3207/src/s3/01/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["size", "onMouseDown", "onClick", "onClear"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import '../../CloseButton/CloseIcon.mjs';
import { CloseButton } from '../../CloseButton/CloseButton.mjs';
var ComboboxClearButton = forwardRef(function (_ref, ref) {
  var size = _ref.size,
    _onMouseDown = _ref.onMouseDown,
    _onClick = _ref.onClick,
    onClear = _ref.onClear,
    others = _objectWithoutProperties(_ref, _excluded);
  return /* @__PURE__ */jsx(CloseButton, _objectSpread(_objectSpread({
    ref: ref,
    size: size || "sm",
    variant: "transparent",
    tabIndex: -1,
    "aria-hidden": true
  }, others), {}, {
    onMouseDown: function onMouseDown(event) {
      event.preventDefault();
      _onMouseDown === null || _onMouseDown === void 0 || _onMouseDown(event);
    },
    onClick: function onClick(event) {
      onClear();
      _onClick === null || _onClick === void 0 || _onClick(event);
    }
  }));
});
ComboboxClearButton.displayName = "@mantine/core/ComboboxClearButton";
export { ComboboxClearButton };